import { render, staticRenderFns } from "./Paineis.vue?vue&type=template&id=7d8704c4"
import script from "./Paineis.vue?vue&type=script&lang=js"
export * from "./Paineis.vue?vue&type=script&lang=js"
import style0 from "./Paineis.vue?vue&type=style&index=0&id=7d8704c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports